import _decode from "./decode";
import _encode from "./encode";
var exports = {};
exports.decode = exports.parse = _decode;
exports.encode = exports.stringify = _encode;
export default exports;
export const decode = exports.decode,
      parse = exports.parse,
      encode = exports.encode,
      stringify = exports.stringify;